import React from 'react'

const Footer = () =>{
    return(
            <footer>
            <div className="footer-container">
                <p>Projet réalisé par Gaetan Dc 2020</p>
                <p>Lien des source et du projet pour plus tard.s</p>
            </div>

            </footer>
    )
}

export default Footer